import React from 'react';
import Breadcrumb from '../../Shared/BreadCumb';
import { getAllLists, getAllAudit } from './services/audit';

import ClipLoader from "react-spinners/ClipLoader";
import { MagnifyingGlassIcon, FunnelIcon, ChevronDownIcon, ChevronUpIcon, CalendarIcon } from '@heroicons/react/20/solid'
import NoAccesComponent from '../../Shared/NoAccesComponent';
import ResponsiveTable from '../../Shared/ResponsiveTable';

export default class AuditComponent extends React.Component {

    BreadcrumbPages = [
        { name: 'Métricas y Resumen', href: '#', current: false },
        { name: 'Auditoría', href: '#', current: true },
    ]

    columns = [
        {field:'dateReg', headerName: 'Fecha de registro'},
        {field:'userName', headerName: 'Usuario'},
        {field:'process', headerName: 'Proceso'},
        {field:'descrip', headerName: 'Descripción'},
    ]

    formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    constructor(props){
        super(props);
        this.state = {
            data:[],
            list: [],
            loading:true,
            user:'',
            dateStart:new Date().toISOString().split('T')[0],
            dateEnd:new Date().toISOString().split('T')[0],
            type:'',
            limit:100,
            canSee: false,
            // UI state
            isFiltersOpen: true,
        }
    }

    componentDidMount() {
        this.getAllLists();
        this.permissions()
    }

    permissions = () => {
        let permissions = window.localStorage.getItem('permissons');
        const userType = window.localStorage.getItem('userType');
        if(userType === 'ANALISTA') { 
            permissions = JSON.parse(permissions);
            let canSee = false;
            permissions[0].vehicles.forEach(element => {
                if(element.name === 'see' && element.value === true){
                    canSee = true;
                }
        });
            this.setState({canSee:canSee, loading:false});
        }else{
            this.setState({canSee:true, loading:false});
        }
    }

    getAllLists() {
        getAllLists().then((res) =>{
            if(res && res.data){
                this.setState({list: res.data.data, loading:false});
            }
        }).catch((error) => console.log(error))
    }

    formatDate = (date) => {
        const fecha = new Date(date);
        const horas = fecha.getHours();
        const minutos = fecha.getMinutes();
        const ampm = horas >= 12 ? 'PM' : 'AM';
        const horaFormateada = horas % 12 || 12;
        return `${fecha.getFullYear()}-${(fecha.getMonth() + 1).toString().padStart(2, '0')}-${fecha.getDate()} ${horaFormateada}:${minutos.toString().padStart(2, '0')} ${ampm}`;
    } 

    getList() {
        if(this.state.dateStart === '' || this.state.dateEnd === '') {
            return alert("Debe de seleccionar las fechas");
        }

        const dateStart = new Date(this.state.dateStart).toISOString();
        const dateEnd = new Date(this.state.dateEnd).toISOString();
        const body = {
            userName: this.state.user,
            type:parseInt(this.state.type),
            limit:parseInt(this.state.limit),
            dateStart,
            dateEnd
        }
        this.setState({loading:true});
        getAllAudit(body).then((res) =>{
            if(res && res.data){
                this.setState({data: res.data.data, loading:false});
            }else{
                alert('No existen registros para esta solicitud');
                this.setState({loading:false})
            }
        }).catch((error) => {
            this.setState({loading:false})
            console.log(error)
        })

    }

    renderForm = () => {
        return(
            <div className="py-6">
                <div className="mb-8">
                    <h2 className="text-2xl font-bold text-gray-900 mb-2">Auditoría del Sistema</h2>
                    <p className="text-gray-600">Consulta el historial de actividades y procesos del sistema</p>
                </div>

                {/* Panel de filtros */}
                <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200">
                    {/* Header del panel de filtros */}
                    <div className="flex items-center justify-between p-4 border-b border-gray-200">
                        <div className="flex items-center space-x-2">
                            <FunnelIcon className="h-5 w-5 text-gray-500" />
                            <h3 className="text-lg font-semibold text-gray-900">Filtros de Auditoría</h3>
                        </div>
                        <button
                            onClick={() => this.setState({isFiltersOpen: !this.state.isFiltersOpen})}
                            className="flex items-center text-sm text-gray-600 hover:text-gray-900"
                        >
                            {this.state.isFiltersOpen ? 'Ocultar' : 'Mostrar'} filtros
                            {this.state.isFiltersOpen ? 
                                <ChevronUpIcon className="ml-1 h-4 w-4" /> : 
                                <ChevronDownIcon className="ml-1 h-4 w-4" />
                            }
                        </button>
                    </div>
                    
                    {/* Contenido del panel de filtros */}
                    {this.state.isFiltersOpen && (
                        <div className="p-6">
                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
                                <div>
                                    <label htmlFor="user" className="block text-sm font-medium text-gray-700 mb-2">
                                        Usuario
                                    </label>
                                    <input
                                        id="user"
                                        onChange={(e) => {this.setState({user:e.target.value})}}
                                        type="text"
                                        placeholder=""
                                        className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="dateStart" className="block text-sm font-medium text-gray-700 mb-2">
                                        <CalendarIcon className="inline h-4 w-4 mr-1" />
                                        Fecha Inicio
                                    </label>
                                    <input
                                        id="dateStart"
                                        value={this.state.dateStart}
                                        onChange={(e) =>{this.setState({dateStart:e.target.value})}}
                                        type="date"
                                        className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="dateEnd" className="block text-sm font-medium text-gray-700 mb-2">
                                        <CalendarIcon className="inline h-4 w-4 mr-1" />
                                        Fecha Fin
                                    </label>
                                    <input
                                        id="dateEnd"
                                        value={this.state.dateEnd}
                                        onChange={(e) =>{this.setState({dateEnd:e.target.value})}}
                                        type="date"
                                        className="block w-full rounded-md border-0 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                    />
                                </div>

                                <div>
                                    <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-2">
                                        Tipo de Proceso
                                    </label>
                                    <div className="relative">
                                        <select
                                            id="type"
                                            onChange={(e) => this.setState({type:e.target.value})}
                                            className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                        >
                                            <option value="">Seleccionar tipo...</option>
                                            {this.state.list?.map((item, index) => {
                                                return(
                                                    <option key={index} value={item.key}>{item.value}</option>
                                                )
                                            })}
                                        </select>
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="limit" className="block text-sm font-medium text-gray-700 mb-2">
                                        Límite de Registros
                                    </label>
                                    <div className="relative">
                                        <select
                                            id="limit"
                                            onChange={(e) => {this.setState({limit:e.target.value})}}
                                            value={this.state.limit}
                                            className="block w-full rounded-md border-0 py-2 pl-3 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                                        >
                                            <option value={0}>Todos los registros</option>
                                            <option value={10}>10 registros</option>
                                            <option value={50}>50 registros</option>
                                            <option value={100}>100 registros</option>
                                            <option value={500}>500 registros</option>
                                            <option value={1000}>1000 registros</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Botón de búsqueda */}
                            <div className="mt-6">
                                <button 
                                    onClick={() => {this.getList()}}
                                    className="inline-flex items-center justify-center px-4 py-2 text-sm font-semibold text-white bg-blue-950 rounded-md shadow-sm hover:bg-blue-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-950"
                                >
                                    <MagnifyingGlassIcon aria-hidden="true" className="h-4 w-4 mr-2" />
                                    Buscar Auditoría
                                </button>
                            </div>
                        </div>
                    )}
                </div>

                {/* Tabla de resultados */}
                {this.state.data.length > 0 && (
                    <div className="mt-8 bg-white rounded-lg shadow-sm ring-1 ring-gray-200 overflow-hidden">
                        <div className="px-6 py-4 border-b border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-900">Resultados de Auditoría</h3>
                            <p className="text-sm text-gray-600">
                                {this.state.data.length} registro(s) encontrado(s)
                            </p>
                        </div>
                        <div className="w-full">
                            <ResponsiveTable columns={this.columns} data={this.state.data}/>
                        </div>
                    </div>
                )}
            </div>
        )
    }
    
    render()
    {
        return(
            <div className="max-w-7xl mx-auto px-4">
                <Breadcrumb pages={this.BreadcrumbPages}/>
                
                {this.state.loading ? (
                    <div className="text-center py-12">
                        <ClipLoader
                            color={'#1e40af'}
                            loading={true}
                            size={50}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                        />
                        <p className="mt-2 text-sm text-gray-600">Cargando datos...</p>
                    </div>
                ) : (
                    this.state.canSee ? this.renderForm() : <NoAccesComponent/>
                )}
            </div>
        )
    }
}